// Scoped to product gallery/lightbox images only - see sections/main-product.liquid.
// This only blocks the browser's native right-click menu and native drag-to-save
// gesture on these specific images. It does NOT prevent screenshots, browser
// dev-tools/network-tab access to the image URL, printing, or every mobile
// long-press variant - it's a casual-copying deterrent, not real protection.
(function () {
  var selector = '.product-gallery img, .product-media-modal img, .product-media-modal__content img';

  function block(event) {
    event.preventDefault();
  }

  document.addEventListener('contextmenu', function (event) {
    if (event.target.closest(selector)) block(event);
  });

  document.addEventListener('dragstart', function (event) {
    if (event.target.closest(selector)) block(event);
  });
})();
